import styles from '../styles/LandingPage.module.css';
import Corfu from "../images/corfu.jpg";
import Hero from "./Hero";
import Discover from "../images/dicover.jpg";
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";

export default function LandingPage() {
  const navigate = useNavigate();
  const { lang } = useParams();
  const { t } = useTranslation();

  const go = (path) => navigate(`/${lang}${path}`);

  return (
    <>
      <Hero />
      <main className={styles.main}>

      <section className={styles.section}>

        {/* SECTION 1 TEXT */}
        <div className={styles.text}>
          <h1>{t("services.title")}</h1>

          <p>{t("services.description")}</p>
          <p>{t("services.details")}</p>
          <p>{t("fleet.description")}</p>
        </div>

        {/* IMAGE 1 */}
        <div
          className={styles.image}
          onClick={() => go("/discover")}
        >
          <img src={Corfu} alt="Corfu island transfers" />
        </div>

        {/* SECTION 2 TEXT */}
        <div className={styles.text}>
          <h1>{t("safety.title")}</h1>
          <p>{t("safety.description")}</p>
        </div>

        {/* IMAGE 2 */}
        <div
          className={styles.image}
          onClick={() => go("/discover")}
        >
          <img src={Discover} alt="Discover Corfu" />
        </div>

      </section>

    </main>
    </>
  );
}